import type { RouteLocationNormalizedGeneric, Router } from 'vue-router';

export function forceRedirectToClearCache(router: Router) {
  router.onError((error: { message: string }, to: RouteLocationNormalizedGeneric) => {
    if (error.message.includes('Failed to fetch dynamically imported module')) {
      window.location = to.fullPath as unknown as string & Location;
    }
  });
}
